import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Routes } from '../frame';
import { CalculatorConfigsListPage } from './components/CalculatorConfigsListPage';
import { CalculatorConfigEditPage } from './components/CalculatorConfigEditPage';

export interface CalculatorRoutesProps {
  apiPath: string;
}

export const CalculatorRoutes = ({ apiPath }: CalculatorRoutesProps) => {
  const { path } = useRouteMatch();

  return (
    <Routes
      routes={[
        {
          path: `${path}/:id`,
          component: () => <CalculatorConfigEditPage apiPath={apiPath} pagePath={path} />,
        },
        {
          path: `${path}/`,
          component: () => <CalculatorConfigsListPage apiPath={apiPath} />,
        },
      ]}
    />
  );
};
